import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ui-product-bundle-label',
  imports: [],
  template: 'Paketaktion',
  styleUrl: './product-bundle-label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductBundleLabelComponent {
}
